<template>
	<el-drawer :modal="false"  
		ref="drawer_detail_com_sum" 
		title="Detail Final Summary Commitment" 
		@opened="initSelected()"
		:visible.sync="drawerDetailFinalCommitmentSummary"
		class="drawer-detail-com-sum" size="50%">
		<div class="proposal-table px-3">
			<el-table 
				ref="multiSelectComm" 
				:data="tableData" 
				style="width: 100%" 
				@selection-change="setSelected"
				:summary-method="getSummaries"
    		:show-summary="true"
				:row-class-name="setRowClass"
				:border="true" 
				size="small">
				<el-table-column type="selection" width="50" ></el-table-column>
				<el-table-column type="index" label="No" width="50" :align="'center'"> </el-table-column>
				<el-table-column label="Summary Current Credit Facility Items" width="250">
					<template slot-scope="scope">
						<p class="mx-2">
							{{ itemName(scope.row) }}
						</p>
					</template>
				</el-table-column>
				<el-table-column label="Facility Status" :align="'center'">
					<template slot="header">
						Facility <br/> Status
					</template>
					<template slot-scope="scope">
						{{ scope.row.pcom_is_additional == 0 ? "Existing Facility" : "New Facility" }}
					</template>
				</el-table-column>
				<el-table-column label="Limit" :align="'center'">
					<template slot-scope="scope">
						{{ limitAmount(scope.row) | moneyFormatter }}
					</template>
				</el-table-column>
				<el-table-column label="Before Instl." :align="'center'">
					<template slot-scope="scope">
						{{ beforeAmount(scope.row) | moneyFormatter }}
					</template>
				</el-table-column>
				<el-table-column label="After Instl." :align="'center'">
					<template slot-scope="scope">
						{{ scope.row.pcom_final_installment | moneyFormatter }}
					</template>
				</el-table-column>
			</el-table>
			<div class="text-right mt-3">
				<el-button class="bg-primary text-white py-2" icon="fa fa-save" @click="update" :loading="is_loading"> Update</el-button>
			</div>
		</div>
	</el-drawer>
</template>
<script>
import { Drawer, Button, Table, TableColumn } from 'element-ui'
import _ from 'lodash'
import { mapActions, mapState } from 'pinia'
import { useInitialProposalStore } from '@/stores/initialProposalStore'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'

export default {
	props: ['allCommitment'],
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Drawer.name]: Drawer,
		[Button.name]: Button
	},
	data() {
		return {
			tableData: [],
			selectedItems:[], 
			drawerDetailFinalCommitmentSummary: false,
			is_loading:false
		}
	},
	watch: {
		allCommitment: {
			handler(newVal) {
				this.tableData = newVal
			},
			immediate: true,
		}
	},
	methods: {
		...mapActions(useInitialProposalStore, ['updateProposalCommitment']),
		viewDetailOutflow() {
			this.drawerDetailFinalCommitmentSummary = !this.drawerDetailFinalCommitmentSummary;
		},
		initSelected() {
			this.$refs.multiSelectComm.clearSelection();
			if (!_gHlp.isEmpty(this.tableData)) {
				this.tableData.forEach(row => {
					if(row.pcom_is_include){
						this.$refs.multiSelectComm.toggleRowSelection(row);
					}
				});
			} 
		},
		setSelected(val) {
			this.selectedItems = val
		},
		itemName(item) {
			let label = '';
			if (!_gHlp.isEmpty(item)) {
				if (item.pcom_type == 'CCRIS') {
					label += item.pcom_capacity || 'N/A';
					label += ' - ';
					label += item.pcom_loan_statue || 'N/A'
					label += ' - ';
					label += item.pcom_bank_code || 'N/A'
				} else {
					label = item.pcom_loan_statue || 'N/A';
				}
			}
			return label;
		},
		limitAmount(item) {
			if (!_gHlp.isEmpty(item)) {
				if (item.pcom_type == 'CCRIS') {
					return parseFloat(item.pcom_credit_limit);
				} else {
					return (!_gHlp.isEmpty(item.pcom_product_detail)) ? parseFloat(item.pcom_product_detail.pcp_loan_amount) : 0;
				}
			}
		},
		beforeAmount(item) {
			if (!_gHlp.isEmpty(item)) {
				if (item.pcom_type == 'CCRIS') {
					return parseFloat(item.pcom_current_installment);
				} else {
					// return (!_gHlp.isEmpty(item.pcom_product_detail)) ? item.pcom_product_detail.pcp_loan_amount : 0;
					return 0;
				}
			}
		},
		getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
					if(index < 3 ) return;
					if (index == 3) {
            sums[index] = 'Total Selected';
            return;
          }

          const values = data.map((item) => {
						let selectedItem = this.selectedItems.find((o)=>{ return o.pcom_id == item.pcom_id });
						
						let lm = !_gHlp.isEmpty(selectedItem) ? this.limitAmount(selectedItem) : 0
						let bf = !_gHlp.isEmpty(selectedItem) ? this.beforeAmount(selectedItem) : 0
						let af = !_gHlp.isEmpty(selectedItem) ? selectedItem.pcom_final_installment : 0

						return {
							limit : lm,
							before : bf,
							after : af
						};
					});

					if(index == 4){
						sums[index] = _gHlp.formatToMoney(_.sumBy(values,(o)=>{ return parseFloat(o.limit) }));
					}
					if(index == 5){
						sums[index] = _gHlp.formatToMoney(_.sumBy(values,(o)=>{ return parseFloat(o.before) }));
					}
					if(index == 6){
						sums[index] = _gHlp.formatToMoney(_.sumBy(values,(o)=>{ return parseFloat(o.after) }));
					}

				});

        return sums;
      
		},
		setRowClass(params){
			const { row, index } = params;
			let selectedItem = this.selectedItems.find((o)=>{ return o.pcom_id == row.pcom_id });
			return !_gHlp.isEmpty(selectedItem) ? "bg-success":"";
		},
		async update(){
			//UPDATE ONLY ITEM HAVE UPDATE
			this.is_loading = true;

			for (const row of this.tableData) {
				let selectedItem = this.selectedItems.find((o)=>{ return o.pcom_id == row.pcom_id });
				let is_include = !_gHlp.isEmpty(selectedItem) ? 1 : 0;
				if(row.pcom_is_include != is_include){
					let data = {
						pcom_is_include:is_include
					}		
					await this.updateProposalCommitment(data,row.pcom_id);
				}
			}
			
			initialProposalEventBus.$emit('refresh-proposal-detail');
			this.is_loading = false;
			this.drawerDetailFinalCommitmentSummary = false;
		}
	}
}
</script>